import request from '../../src/js/oc-request/oc-request'
import { Modal } from 'bootstrap';

export default new class Consult {
    constructor() {
        this.init()
    }

    init() {
        let _self = this

        $('.phonemask').mask('+7(000)000-00-00');

        // Comment complete
        // let consultForm = document.querySelector('#mainConsultForm');
        document.querySelectorAll('.consultForms').forEach((consultForm) => {
            consultForm.addEventListener('submit', function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (consultForm.checkValidity()) {
                    request.sendForm(consultForm, 'onFormSubmit', {
                        files: true,
                        success: () => {
                            _self.init()
                            var myModal = new Modal(document.getElementById('mainConsultFormSend'))
                            myModal.toggle();
                            consultForm.reset()
                        },
                        error: () => {
                            _self.init()
                            var myModal = new Modal(document.getElementById('sendError'))
                            myModal.toggle();
                        }
                    })
                }
            });
        })
    }
}
